import { ATTACHMENT_ENTITY_TYPE } from '@/api/resources/attachment/attachmentResource'
import { CaseOperationGuardMixin } from '@/api/operations/mixins/guards/case-operation-guard.mixin'
import { ComplementaryOperationGuardMixin } from '@/api/operations/mixins/guards/complementary-operation-guard.mixin'
import { SampleOperationGuardMixin } from '@/api/operations/mixins/guards/sample-operation-guard.mixin'
import { PortionOperationGuardMixin } from '@/api/operations/mixins/guards/portion-operation-guard.mixin'
import { SubportionOperationGuardMixin } from '@/api/operations/mixins/guards/subportion-operation-guard.mixin'

export default {
    mixins: [
        CaseOperationGuardMixin,
        ComplementaryOperationGuardMixin,
        SampleOperationGuardMixin,
        PortionOperationGuardMixin,
        SubportionOperationGuardMixin
    ],
    methods: {
        setEntitiesIdArray(entity, laboratoryId) {
            switch (entity.attachmentEntityType) {
            case ATTACHMENT_ENTITY_TYPE.PATIENT:
                return [entity.patientId]
            case ATTACHMENT_ENTITY_TYPE.CASE:
                return [laboratoryId, entity.caseId]
            case ATTACHMENT_ENTITY_TYPE.SAMPLE:
                return [laboratoryId, entity.caseId, entity.sampleId]
            case ATTACHMENT_ENTITY_TYPE.COMPLEMENTARY:
                return [laboratoryId, entity.caseId, entity.complementaryId]
            case ATTACHMENT_ENTITY_TYPE.PORTION:
                return [laboratoryId, entity.caseId, entity.sampleId, entity.portionId]
            case ATTACHMENT_ENTITY_TYPE.SUBPORTION:
                return [laboratoryId, entity.caseId, entity.sampleId, entity.portionId, entity.subportionId]
            default:
                return []
            }
        },
        canAttachDocumentsToEntityType(entity) {
            switch (entity.attachmentEntityType) {
            case ATTACHMENT_ENTITY_TYPE.CASE:
                return this.$_canAttachDocumentToCase()
            case ATTACHMENT_ENTITY_TYPE.COMPLEMENTARY:
                return this.$_canAttachDocumentToComplementary()
            case ATTACHMENT_ENTITY_TYPE.SAMPLE:
                return this.$_canAttachDocumentToSample()
            case ATTACHMENT_ENTITY_TYPE.PORTION:
                return this.$_canAttachDocumentToPortion()
            case ATTACHMENT_ENTITY_TYPE.SUBPORTION:
                return this.$_canAttachDocumentToSubportion()
            default:
                return false
            }
        }
    }
}
